export const version = "web/5.0.11";
//# sourceMappingURL=_version.js.map